export const SETTINGS = {
  CUSTOMISE: 'Customise',
  CALENDAR: 'CalendarMode',
};
